import React from 'react';
import Field from '../Field';
import ComboBox from '../ComboBox';

const ComboBoxField = props => (
  <Field {...props}>
    <ComboBox />
  </Field>
);

export default ComboBoxField;
